import React from 'react'
import {
    Box,
    Button,
    Flex,
    Text,
} from "@chakra-ui/react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { SelectAudience } from '../../components/SelectAudience';
import { PK_12 } from '../../components/PK_12';
import { HigherEd } from '../../components/HigherEd';
import { CourseDetails } from '../../components/CourseDetails';
import { CreationMode } from '../../components/CreationMode';
import { ResourceFileUpload } from '../../components/ResourceFileUpload';
import { CreateAIContentLoader } from '../../components/CreateAIContentLoader';
import { LoadingOverlay } from '../../components/LoadingOverlay';
import { Outline } from '../../components/Outline';
import { ModalBox } from '../../components/ModalBox';
import { Professional } from '../Professional';
import { Hobby } from '../Hobby';
import { UploadingOverlay } from '../UploadingOverlay';
import { useStore } from "../../Store";


export const CreateProductPageUI = (
    {
        dynoCategories,
        loading,
        handleBack,
        handleNext,
        createContent,
        setPrompt,
        onProductDetailSubmit,
        createProductInDB,
        isOpen,
        onOpen,
        onClose,
        generateContent,
        extractTextFromAllFiles,
        prompt,
        product,
        currentStep,
        progressLoading,
        type,
        selectedFilesFromGallery, 
        selectedNewFiles,
        isUploadingFromCreateProduct,
        loadingMessage,
        onOutlineChange,
        onModuleTitleChange,
        editMode, 
        setEditMode
    }
) => {
    const {bookIsUploading, courseIsUploading, bookOutline, courseOutline} = useStore((state) => state);
    let isUploading = type === "book" ? bookIsUploading : courseIsUploading
    let outline = type === "book" ? bookOutline : courseOutline
    return (
        <>
            {loading && <LoadingOverlay loadingMessage={loadingMessage}/>}
            {isUploadingFromCreateProduct && <UploadingOverlay loadingMessage={loadingMessage}/>}
            <Box py={8}>
                {progressLoading ?
                    <CreateAIContentLoader /> :
                    <>
                        {
                            outline.modules?.length > 0 ? <></> :
                                <Flex justifyContent={"flex-end"}>
                                    <Text fontSize="md" fontWeight="bold">
                                        Step {currentStep} / 5
                                    </Text>
                                </Flex>
                        }
                        <form onSubmit={currentStep === 3 ? onProductDetailSubmit : null}>
                            {currentStep === 1 && <SelectAudience dynoCategories={dynoCategories} product={product} type={type}/>}

                            {currentStep === 2 ?
                                product.category?.name === "PK-12" ?
                                    <PK_12 product={product} type={type}/> :
                                    product.category?.name === "HigherEd" ?
                                        <HigherEd product={product} type={type}/>
                                        : product.category?.name === "Professional" ?
                                         <Professional product={product} type={type}/> : <Hobby product={product} type={type}/> : null
                            }
                            {currentStep === 3 &&
                                <CourseDetails
                                    prompt={prompt}
                                    setPrompt={setPrompt}
                                    createContent={createContent}
                                    product={product}
                                    loading={loading}
                                    type={type}
                                />
                            }
                            {currentStep === 4 && <CreationMode createProductInDB={createProductInDB} type={type} currentStep={currentStep}/>}
                            {currentStep === 5 && <ResourceFileUpload 
                                                    {
                                                        ...{
                                                            selectedFilesFromGallery, 
                                                            selectedNewFiles,
                                                            extractTextFromAllFiles,
                                                            createProductInDB,
                                                            type,
                                                        }
                                                    }
                                                  />}

                            <Flex justify="space-between" mt={6}>
                                { currentStep > 1 && !isUploading  ?
                                    <Button leftIcon={<FaArrowLeft />} colorScheme="blue" variant="ghost" onClick={handleBack} isDisabled={loading}>
                                        Back
                                    </Button> :
                                    <Button leftIcon={<FaArrowLeft />} colorScheme="blue" variant="ghost" onClick={handleBack} visibility="hidden" isDisabled={loading}>
                                        Back
                                    </Button>
                                }
                                { currentStep !== 3 && currentStep < 4 ? (
                                    <Button rightIcon={<FaArrowRight />} colorScheme="blue" onClick={handleNext} isDisabled={loading} type={"button"}>
                                        Continue
                                    </Button>
                                ) : (
                                    <></>
                                )}
                                { currentStep === 3 ?
                                    <Button rightIcon={<FaArrowRight />} colorScheme="blue" isDisabled={loading} type={"submit"}>
                                        Continue
                                    </Button> : <></>
                                }
                            </Flex>
                        </form>
                    </>
                }
                <ModalBox
                    title="Outline"
                    isOpen={isOpen}
                    onClose={onClose}
                    isFooter={true}
                    onCancel={onClose}
                    confirmButtonType={true}
                    onConfirm={generateContent}
                    confirmButtonText="Save and Generate Content"
                    size="full"
                    description={
                        <Outline 
                            data={outline} 
                            onOutlineChange={onOutlineChange} 
                            onModuleTitleChange={onModuleTitleChange}         
                            editMode={editMode} 
                            setEditMode={setEditMode} />
                    }
                ></ModalBox>
            </Box>
        </>
    )
}
